import { IAssetMappingConfiguration } from '../../interfaces/iasset-mapping-configuration';
import { AssetSuperType } from '../asset-super-type';
import { Module } from '../module';
import { ProjectType } from '../project-type';

export class AssetMappingConfigurationBase {
  AssetMappingConfigurationId: number;
  ProjectTypeId: number;
  AssetSuperTypeId: number | null;
  ModuleId: number;
  IsConstructedModule: boolean;
  IsAllowAllocation: boolean;
  AssetTypeFilters: string | null;
  ProjectStatusEditable: string | null;
  Sequence: number | null;
  Created: Date | null;
  CreatedBy: string | null;
  Updated: Date | null;
  UpdatedBy: string | null;
  IsSingleInstanceAsset: boolean | null;
  IsTankBatterySource: boolean | null;
  IsOwidEditable: boolean | null;
  IsWellReassignment: boolean | null;

  AssetSuperType?: AssetSuperType;
  Module?: Module;
  ProjectType?: ProjectType;

  constructor(item?: IAssetMappingConfiguration) {
    if (item) {

      this.AssetMappingConfigurationId = item.AssetMappingConfigurationId;
      this.ProjectTypeId = item.ProjectTypeId;
      this.AssetSuperTypeId = item.AssetSuperTypeId;
      this.ModuleId = item.ModuleId;
      this.IsConstructedModule = item.IsConstructedModule;
      this.IsAllowAllocation = item.IsAllowAllocation;
      this.AssetTypeFilters = item.AssetTypeFilters;
      this.ProjectStatusEditable = item.ProjectStatusEditable;
      this.Sequence = item.Sequence;
      this.Created = item.Created ? new Date(item.Created) : null;
      this.CreatedBy = item.CreatedBy;
      this.Updated = item.Updated ? new Date(item.Updated) : null;
      this.UpdatedBy = item.UpdatedBy;
      this.IsSingleInstanceAsset = item.IsSingleInstanceAsset;
      this.IsTankBatterySource = item.IsTankBatterySource;
      this.IsOwidEditable = item.IsOwidEditable;
      this.IsWellReassignment = item.IsWellReassignment;

      this.AssetSuperType = new AssetSuperType(item.AssetSuperType);
      this.Module = new Module(item.Module);
      this.ProjectType = new ProjectType(item.ProjectType);
    }
  }
}